/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import { ThemeConsumer } from '@cvent/carina-theme-provider';
import ButtonLayoutStyle from './ButtonLayoutStyle';

/** DEPRECATED */
export default class ButtonLayout extends React.Component {
  static propTypes = {
    /** Provide one or more Button (or similar) elements to be rendered in a row, with padding and alignment */
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.element
    ]).isRequired,

    /** Adds alignment appropriate for dialog boxes. Aligns children left for LTR layouts */
    alignStart: PropTypes.bool,

    /** right-to-left text direction */
    isRtl: PropTypes.bool
  };

  static defaultProps = {
    alignStart: false,
    isRtl: false
  };

  componentDidMount() {
    /* eslint-disable no-console */
    console.error(
      '[ButtonLayout] DEPRECATED \nThis component should no longer be used. \nUse <Col width="content"> instead.'
    );
    /* eslint-enable no-console */
  }

  render() {
    /* eslint-disable react/prop-types */
    // dialog prop is included to ease transition to new 'alignStart' api. It can be removed in a future release.
    const { alignStart, isRtl, children, dialog } = this.props;
    /* eslint-enable react/prop-types */
    return (
      <ThemeConsumer>
        {theme => {
          const styles = new ButtonLayoutStyle({
            theme,
            alignStart: alignStart || dialog,
            isRtl
          });
          return (
            <div css={styles.container}>
              {this.wrapChildren(children, styles)}
            </div>
          );
        }}
      </ThemeConsumer>
    );
  }

  wrapChildren = (children, styles) =>
    React.Children.map(children, (child, index) => (
      <div css={styles.item} key={index}>
        {child}
      </div>
    ));
}
